import PassengerInfo from '@/components/purchase/checkout/PassengerInfo';
import type { PersonDataField } from '@/hooks/usePersonFieldRenderer';
import { getPassengerName } from '@/utils/passenger';
import type { CheckoutValues } from '@/utils/zodSchema';
import { Divider, Typography } from '@fleet/webshop-ui';
import { Fragment, type FC } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

interface PassengerListProps {
  formFields: Array<PersonDataField>;
}

const PassengerList: FC<PassengerListProps> = ({ formFields }) => {
  const { control, watch } = useFormContext<CheckoutValues>();
  const { fields } = useFieldArray({
    control,
    name: 'passengers',
  });
  const passengers = watch('passengers');

  return (
    <div className="flex flex-col gap-3">
      {fields.map(({ id }, index) => {
        const passenger = passengers[index];
        return (
          <Fragment key={id}>
            <div
              className="flex flex-col gap-3 tablet:flex-row tablet:gap-6"
              data-testid={`passengers-${index}-content`}
            >
              <div className="tablet:flex-1">
                <Typography
                  variant="body1-bold"
                  className="whitespace-normal break-all text-dark"
                  as="h3"
                >
                  {getPassengerName(passenger, index)}
                </Typography>
              </div>
              <PassengerInfo
                formFields={formFields}
                prefix={`passengers[${index}]`}
              />
            </div>
            {index < fields.length - 1 && <Divider variant="medium" />}
          </Fragment>
        );
      })}
    </div>
  );
};

export default PassengerList;
